module.exports = __webpack_public_path__ + "static/media/Share Icon-01.cf50c645.svg";